export default {
  zh: {
    ruleTxt: `
    <br/>
    1.发送者送出宝箱后，用户满足领取宝箱的条件后即可参与。<br/><br/>
    2.在一个小时内，宝箱无人领取，将返还发送者的账户，并通过通知发送者。<br/><br/>
    3.宝箱的礼物会自动发送到用户的背包。<br/><br/>
    4.宝箱发送后不能撤销。<br/>
    `
  },
  en: {
    ruleTxt: `
    <br/>
    1.After the sender sends out the chest, the user can participate after meeting the conditions for receiving the chest.<br/><br/>
    2. If no one picks up the chest within one hour, it will be returned to the sender's account and the sender will be notified.<br/><br/>
    3. The gift of the  chest will be automatically sent to the user's backpack.<br/><br/>
    4. Once the chest is sent, it cannot be revoked.<br/>
    `
  },
  ar: {
    ruleTxt: `
    <br/>
    1.بعد أن يرسل المرسل الصندوق ، يمكن للمستخدم المشاركة بعد استيفاء شروط استلام الصندوق.<br/><br/>
    2. إذا لم( ياخذ) أحد الصندوق في غضون ساعة واحدة ، فسيتم إعادته إلى حساب المرسل وسيتم إخطار المرسل.<br/><br/>
    3. سيتم إرسال هدية الصندوق تلقائيًا إلى (الحقيبة  )الخاصة بالمستخدم.<br/><br/>
    4. بمجرد إرسال الصندوق ، لا يمكن إلغاؤه.<br/>
    `
  },
  tr:{
    "ruleTxt": `
    <br/>
    1. Gönderen sandığı gönderdikten sonra, kullanıcı sandığı alma koşullarını karşıladıktan sonra katılabilir.<br/><br/>
    2. Eğer bir saat içinde kimse sandığı almazsa, gönderenin hesabına geri dönecek ve gönderene bildirim yapılacaktır.<br/><br/>
    3. Sandığın hediyesi otomatik olarak kullanıcının sırt çantasına gönderilecektir.<br/><br/>
    4. Sandık bir kez gönderildiğinde geri alınamaz.<br/>
    `
},
    pt:{
    "ruleTxt": `
    <br/>
    1. Depois que o remetente enviar o baú, o usuário poderá participar após atender às condições para recebê-lo.<br/><br/>
    2. Se ninguém pegar o baú dentro de uma hora, ele será retornado para a conta do remetente e o remetente será notificado.<br/><br/>
    3. O presente do baú será enviado automaticamente para a mochila do usuário.<br/><br/>
    4. Uma vez enviado, o baú não pode ser revogado.<br/>
    `
},
    id:{
    "ruleTxt": `
    <br/>
    1. Setelah pengirim mengirimkan peti, pengguna dapat berpartisipasi setelah memenuhi syarat untuk menerimanya.<br/><br/>
    2. Jika tidak ada yang mengambil peti dalam satu jam, peti akan dikembalikan ke akun pengirim dan pengirim akan diberitahu.<br/><br/>
    3. Hadiah dari peti akan secara otomatis dikirim ke ransel pengguna.<br/><br/>
    4. Setelah peti dikirim, tidak dapat dibatalkan.<br/>
    `
},
    uz:{
    "ruleTxt": `
    <br/>
    1. Jo'natuvchi sandiqli yuborgandan so'ng, foydalanuvchi uni qabul qilish shartlarini bajargandan keyin ishtirok etishi mumkin.<br/><br/>
    2. Agar bir soat ichida hech kim sandiqli olmasa, u jo'natuvchining hisobiga qaytariladi va jo'natuvchiga xabar beriladi.<br/><br/>
    3. Sandiqli sovg'asi avtomatik ravishda foydalanuvchining ryukzakiga yuboriladi.<br/><br/>
    4. Sandiqli jo'natilgandan so'ng, uni bekor qilib bo'lmaydi.<br/>
    `
},
    ru:{
    "ruleTxt": `
    <br/>
    1. После отправки сундука отправителем пользователь может принять участие после выполнения условий для его получения.<br/><br/>
    2. Если в течение часа никто не заберет сундук, он будет возвращен на счет отправителя, и отправитель получит уведомление.<br/><br/>
    3. Подарок из сундука будет автоматически отправлен в рюкзак пользователя.<br/><br/>
    4. После отправки сундука его невозможно отменить.<br/>
    `
},
    fa:{
    "ruleTxt": `
    <br/>
    1. پس از ارسال صندوق توسط فرستنده، کاربر می‌تواند پس از برآورده کردن شرایط دریافت صندوق، در آن شرکت کند.<br/><br/>
    2. اگر هیچ‌کس ظرف یک ساعت صندوق را برندارد، به حساب فرستنده بازگردانده شده و به او اطلاع داده خواهد شد.<br/><br/>
    3. هدیه داخل صندوق به‌طور خودکار به کوله‌پشتی کاربر ارسال می‌شود.<br/><br/>
    4. پس از ارسال صندوق، امکان لغو آن وجود ندارد.<br/>
    `
}






}


// WEBPACK FOOTER //
// src/pages/activity/caserule/lang.js